@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.toggleWrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  &:focus-within {
    outline: none;
  }
}

.toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  transition: all v.$transition-duration ease-in-out;
  cursor: pointer;
  outline: none;

  &:focus {
    outline: 2px solid v.$palette-orange-1;
    outline-offset: 2px;
  }

  // Size variants
  &.small {
    width: 37px;
    height: 22px;

    .thumb {
      width: 20px;
      height: 20px;
      transform: translateX(2px);
    }

    &.checked .thumb {
      transform: translateX(16px);
    }
  }

  &.medium {
    width: 44px;
    height: 24px;

    .thumb {
      width: 20px;
      height: 20px;
      transform: translateX(2px);
    }

    &.checked .thumb {
      transform: translateX(22px);
    }
  }

  &.large {
    width: 56px;
    height: 32px;

    .thumb {
      width: 28px;
      height: 28px;
      transform: translateX(2px);
    }

    &.checked .thumb {
      transform: translateX(26px);
    }
  }

  // State styles
  &.checked {
    .track {
      background-color: v.$palette-orange-2;
    }

    .thumb {
      background-color: v.$palette-white;
      box-shadow: v.$shadow2;
    }
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  // Hover effects (only when not disabled)
  &:not(.disabled):hover {
    .track {
      opacity: 0.9;
    }

    .thumb {
      box-shadow: v.$shadow1;
    }
  }
}

.track {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: v.$palette-dirty-50; // Inactive gray color
  border-radius: inherit;
  transition: background-color v.$transition-duration ease-in-out;
}

.thumb {
  position: relative;
  z-index: 1;
  background-color: v.$palette-white;
  border-radius: 50%;
  box-shadow: v.$shadow2;
  transition: all v.$transition-duration ease-in-out;

  // Add a subtle border for better definition
  border: 1px solid v.$palette-dirty-40;
}

.label {
  color: v.$palette-black;
  @include t.text(14px, 22px, 600);

  transition: color v.$transition-duration ease-in-out;

  &.disabled {
    color: v.$palette-dirty-50;
  }
}
